import { useNavigate } from "react-router-dom";
import JobForm from "./jobForm";
import JobList from "./jobList";

import Header from "../component/header"
import Footer from "../component/footer"

export default function App() {
    const navigate = useNavigate();
    const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");
  };
  return (
    <>
    <Header/>
      <section className="section object-container">
           <main className="base-container w-container w-container-left">
              <div className="container">
                <button className="nav-link contact--button active" onClick={handleLogout}>Logout</button>
                <h2>Job Opening CRM</h2>
                <JobForm />
                <JobList />
              </div>
           </main>

          
     </section>
   <Footer/>
    </>
  );
}
